import { Box, Flex, Text } from '@chakra-ui/react';

/**
 * A template drawn the way WhatsApp draws it.
 *
 * ★ ONE BUBBLE FOR EVERY PREVIEW. The template editor and the campaign wizard
 * both show "what this looks like on the phone"; two drawings of the same
 * thing drift, and the one people trust least is whichever they saw second.
 * Purely presentational: give it the four parts and it renders them.
 *
 * ★ FOOTER, THEN BUTTONS — BELOW THE FOOTER, BECAUSE THAT IS WHERE WHATSAPP
 * PUTS THEM. A preview showing buttons above the small print would be quietly
 * wrong about the one thing it exists for.
 *
 * Semantic tokens rather than a module palette, so it looks the same inside
 * the finance-shelled wizard and the plain template editor.
 */
export default function TemplateBubble({
	header = '',
	headerKind = 'none',
	body = '',
	footer = '',
	buttons = [],
	time = '10:00',
	stamp = 'Template preview',
	maxW = '340px',
}) {
	const mediaHeader = headerKind !== 'none' && headerKind !== 'text';
	return (
		<Flex justify='flex-end' align='flex-start' w='100%'>
			<Box
				bg='bg.surface'
				borderWidth='1px'
				borderColor='border.default'
				borderRadius='lg'
				borderTopRightRadius='sm'
				p='3.5'
				w='100%'
				maxW={maxW}
				boxShadow='sm'
				position='relative'
			>
				{mediaHeader && (
					<Flex
						align='center'
						justify='center'
						h='120px'
						mb='2'
						borderRadius='md'
						bg='bg.subtle'
						borderWidth='1px'
						borderStyle='dashed'
						borderColor='border.subtle'
					>
						<Text fontSize='xs' color='text.muted' textTransform='capitalize'>
							{headerKind} header
						</Text>
					</Flex>
				)}

				{header && (
					<Text fontWeight='700' fontSize='sm' color='text.primary' mb='2' whiteSpace='pre-wrap'>
						{header}
					</Text>
				)}

				<Text fontSize='sm' color='text.primary' whiteSpace='pre-wrap' wordBreak='break-word'>
					{body || 'Your message body will appear here.'}
				</Text>

				{footer && (
					<Text fontSize='xs' color='text.muted' mt='2.5' whiteSpace='pre-wrap'>
						{footer}
					</Text>
				)}

				<Flex justify='flex-end' align='center' gap='1' mt='1.5'>
					<Text fontSize='0.65rem' color='text.muted'>
						{time}
					</Text>
					<Text fontSize='0.65rem' color='accent.gold' aria-label='delivered' lineHeight='1'>
						✓✓
					</Text>
				</Flex>

				{buttons.map((button, index) => (
					<Box
						// Buttons carry no id; their order is their identity.
						// eslint-disable-next-line react/no-array-index-key
						key={index}
						mt='2'
						pt='1.5'
						borderTopWidth='1px'
						borderColor='border.subtle'
						textAlign='center'
					>
						<Text fontSize='sm' color='accent.gold' noOfLines={1}>
							{button.text}
						</Text>
					</Box>
				))}

				{stamp && (
					<Text fontSize='0.6rem' color='text.muted' textAlign='right' mt='2' opacity={0.8}>
						{stamp}
					</Text>
				)}
			</Box>
		</Flex>
	);
}
